/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLayout} from '../../core'
import {AsideTabs} from './AsideTabs'
import Logo from '../../../assets/everyvisit-logo-white.svg'
import LogoMc from '../../../assets/mc-logo.svg'

const AsideDefault = () => {
  const {classes} = useLayout()
  const [link, setLink] = useState<string>('dashboard')

  return (
    <div
      id='kt_aside'
      className={clsx('aside', classes.aside.join(' '))}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        width: '220px',
        zIndex: 100,
      }}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width='auto'
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_toggle'
    >
      <div className='aside-primary d-flex flex-column align-items-stretch flex-column-fluid h-100 position-relative'>
        {/* begin::Logo */}
        <div
          className='aside-logo d-none d-lg-flex flex-column-auto h-55px align-items-center px-9 bg-primary'
          id='kt_aside_logo'
        >
          <Link to='/dashboard'>
            <div className='d-flex  gap-3 align-items-center justify-content-center'>
              <img alt='Logo' src={LogoMc} className='h-20px' />
              <img alt='Logo' src={Logo} className='h-25px' />
            </div>
          </Link>
        </div>
        {/* end::Logo */}

        <div
          className='aside-nav d-flex flex-column align-items-stretch flex-column-fluid overflow-hidden'
          id='kt_aside_nav'
        >
          <AsideTabs link={link} setLink={setLink} />
        </div>
      </div>
    </div>
  )
}

export {AsideDefault}
